// extracted by mini-css-extract-plugin
export default {"fs12":"LearnType_fs12__ERPEY","btnSave":"LearnType_btnSave__z28mI","ratingButton":"LearnType_ratingButton__JwJJD"};